import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface HistorialCda {
  id?: number;
  placa: string;
  idcda: string;
  centrocda: string;
  fechacda: Date;
  vcda: Date;
  estado: number;
}

@Injectable({
  providedIn: 'root',
})
export class HistorialCdaService {
  private apiUrl =  `${environment.apiUrl}/api/historialcda`; 
  

  constructor(private http: HttpClient) {}

  create(historial: HistorialCda): Observable<HistorialCda> {
    return this.http.post<HistorialCda>(this.apiUrl, historial);
  }

  getAll(): Observable<{ historial: HistorialCda[]; estadisticas: any }> {
    return this.http.get<{ historial: HistorialCda[]; estadisticas: any }>(this.apiUrl);
  }

  getById(id: number): Observable<HistorialCda> {
    return this.http.get<HistorialCda>(`${this.apiUrl}/${id}`);
  }

  getByPlaca(placa: string): Observable<{ historial: HistorialCda[]; estadisticas: any }> {
    return this.http.get<{ historial: HistorialCda[]; estadisticas: any }>(`${this.apiUrl}/placa/${placa}`);
  }

  update(idcda: string, historial: Partial<HistorialCda>): Observable<any> {
    return this.http.put(`${this.apiUrl}/${idcda}`, historial);
  }

  softDeleteById(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  inactivateByIdCda(idcda: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/inactivar/${idcda}`, {});
  }
}
